import ChevronRight from "/public/images/icons/chevronRight.svg?react";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import PropTypes from "prop-types";
import ShopToggle from "../ShopToggle";

export default function ShopDropdown({ index, title, children, showSlider, active, toggleChecked = true, handleToggleChange, error}) {

  const [activeDropdown, setActiveDropdown] = useState(index === 0 ? true : false);

  const isActive = index === 0 ? activeDropdown : active || !toggleChecked || activeDropdown;

  return (
    <div
      className={`flex flex-col justify-between ${  error ? "border-sportsRed" :
        isActive ? "border-[#EAAA00]" : "border-[#E3E3E3]"
      } bg-white border rounded-[8px] py-[16px] px-[12px]`}
      data-testid="dropdown-container"
    >
      <div className={`flex justify-between min-w-full`} onClick={() => (index === 0 ? setActiveDropdown(!activeDropdown) : null)}>
        <div className="flex flex-row items-center gap-x-[20px]">
          <div className="flex cursor-pointer flex-row w-full justify-between items-center font-semibold antialiased">
            {title}
          </div>
        </div>
        <div className="">
          {!showSlider ? (
          <ChevronRight
            data-testid="dropdown-icon"
            className={` ${
              isActive ? "fill-[#EAAA00] -rotate-90" : "fill-black rotate-90"
            } transition-all cursor-pointer`}
          />
          ) : (
            <div className="flex flex-row gap-2 items-center">
              <p className="text-[12px] text-sportsDarkGrey">Details match band 1</p>
              <ShopToggle name={`DetailsMatch-${index}`} defaultChecked={!toggleChecked ? 'off' : 'on'} onChange={handleToggleChange} />
            </div>
          )}
        </div>
      </div>
      <motion.div
        animate={{
          height: isActive ? "auto" : 0,
          marginTop: isActive ? "24px" : 0,
        }}
        initial={{ height: 0, marginTop: 0 }}
        transition={{ duration: 0.5 }}
        className={`overflow-hidden border-dashed border-t border-transparent ${
          isActive && "!border-[#E3E3E3]"
        }`}
        data-testid="dropdown-content"
      >
        <div className="flex flex-col gap-0 pt-[24px]">{children}</div>
      </motion.div>
    </div>
  );
}

ShopDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  children: PropTypes.node.isRequired,
  showSlider: PropTypes.bool,
  error: PropTypes.bool,
};
